<template>
  <div class="archive panel panel-right" :class="{ 'hidden': !visible }">
    <div v-bar="{ preventParentScroll: true, overrideFloatingScrollbar: false }">
      <div>
        <div v-for="film in films" :key="film.id" class="archive-item" :class="{ active: $route.params && $route.params.slug == film.slug }">
          <router-link tabindex="-1" :to="'/film/' + film.slug">
            <span class="photo-aspect-wrapper">
              <div class="thumbnail" :style="{ backgroundImage: `url(${film.thumbnail})` }"></div>
            </span>
            <span class="box-aspect-wrapper">
              <span class="number">{{ zeroPad(film.number, 2) }}</span>
            </span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { zeroPad } from '../../utils'
export default {
  computed: {
    ...mapState({
      visible: state => state.panels.right,
      films: state => state.films
    })
  },
  methods: {
    zeroPad
  }
}
</script>
